export function isMobileDevice() {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }

    // Check for touch support
    const hasTouchSupport = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // Check screen size
    const isSmallScreen = window.innerWidth <= 768;

    // Check user agent string for common mobile keywords
    const userAgent = navigator.userAgent?.toLowerCase?.() || '';
    const mobileKeyWord = ["android", "webos", "iphone", "ipad", "blackberry", "windows phone"];
    const hasMobileKeyword = mobileKeyWord.some(keyword => userAgent.includes(keyword));

    // Combine all checks
    return (hasTouchSupport && isSmallScreen) || hasMobileKeyword;
}
